import {performRequest} from 'shared/utils';

import {IReportConfigurationDataDto} from '../report-configuration-dto';

export type TGetTableReportConfigurationDataRequestArgs = {
    templateCode: string;
}
export const getTableReportConfigurationData = async (args: TGetTableReportConfigurationDataRequestArgs) => {
    const {data: templateConfigurationData} = await performRequest<Partial<IReportConfigurationDataDto>>({
        url: `table-reports/${args.templateCode}`,
        method: 'GET',
    });
    return templateConfigurationData;
};

export type TGetTableReportConfigurationFieldDataArgs = {
    fieldName: keyof IReportConfigurationDataDto;
} & TGetTableReportConfigurationDataRequestArgs;

export const getTableReportConfigurationFieldData = async (args: TGetTableReportConfigurationFieldDataArgs) => {
    const {fieldName, templateCode} = args;

    const {data: templateConfigurationData} = await performRequest<Partial<IReportConfigurationDataDto>>({
        url: `table-reports/${templateCode}/field/${fieldName}`,
        method: 'GET',
    });
    return templateConfigurationData;
};

export type TGetTableReportConfigurationFieldsDataArgs = {
    fieldNames?: (keyof IReportConfigurationDataDto)[];
} & TGetTableReportConfigurationDataRequestArgs;

export const getTableReportConfigurationFieldsData = async (args: TGetTableReportConfigurationFieldsDataArgs) => {
    const {templateCode, fieldNames = []} = args;

    const {data: templateConfigurationData} = await performRequest<Partial<IReportConfigurationDataDto>>({
        url: `table-reports/${templateCode}/fields`,
        method: 'POST',
        data: {
            fieldNameList: fieldNames,
        },
    });
    return templateConfigurationData;
};

export type TPatchTableReportConfigurationArgs = {
    templateCode: string;
    data: Partial<IReportConfigurationDataDto>;
}

export const patchTableReportConfiguration = async (args: TPatchTableReportConfigurationArgs) => {
    const {templateCode, data} = args;

    const response = await performRequest<string>({
        url: `table-reports/${templateCode}`,
        method: 'PATCH',
        data,
    });
    return response;
};

export type TPostTableReportConfigurationArgs = Omit<TPatchTableReportConfigurationArgs, 'templateCode'>;
export const postTableReportConfiguration = async (args: TPostTableReportConfigurationArgs) => {
    const {data} = args;

    const response = await performRequest<string>({
        url: 'table-reports',
        method: 'POST',
        data,
    });
    return response;
};

export type TDeleteTableReportConfigurationArgs = {templateCode: string};
export const deleteTableReportConfiguration = async ({
    templateCode,
}: TDeleteTableReportConfigurationArgs) => {
    const response = await performRequest<string>({
        url: `table-reports/${templateCode}`,
        method: 'DELETE',
    });
    return response;
};
